import axios from '@/utils/axios'

// 保持活跃
const API = {
  init: '/reactive/ajaxInit',
  setModule: '/reactive/ajaxSetReactiveConfig'
}

function initPagePost () {
  return axios.post(API.init)
}

function setModulePost (param) {
  return axios.post(API.setModule, param)
}

export {
  initPagePost,
  setModulePost
}
